import { AdvertentieList } from "./AdvertentieList";
import { KenmerkWerklijst } from "../components/KenmerkWerklijst";

// advertentie-migration (Epic 22/23 Jmix-exit): de Advertenties-overzicht.
//
// Een rij opent het hele dier op zijn advertentietabblad, niet de advertentie op zichzelf (maintainer
// 2026-08-20). Dat is dezelfde editor, maar dan met de kop van het dier eromheen: wie een advertentie
// bijwerkt wil er toch bij kunnen wat er verder over dat dier bekend is. De wrapper houdt daarom geen
// eigen detailstaat meer bij — hij geeft alleen door welk dier geopend moet worden.
export function AdvertentiesOverview({ onOpenAnimal }: { onOpenAnimal?: (dierId: string) => void } = {}) {
  return (
    <>
      {/* De werklijst staat bóven het overzicht en verdwijnt zodra er niets meer open staat
          (epic 12, story 12-9). Een apart menu-item zou een scherm opleveren dat niemand opzoekt;
          hier valt het op bij wie toch al met advertenties bezig is. */}
      <KenmerkWerklijst onOpen={(rij) => rij.dierId != null && onOpenAnimal?.(String(rij.dierId))} />
      <AdvertentieList onOpenDier={(dierId) => onOpenAnimal?.(String(dierId))} />
    </>
  );
}
